"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkValidName = function (name) {
    if (!name)
        return false;
    if (!name.match(/^([a-zA-ZÀ-ÿ- ]{2,}\s[a-zA-ZÀ-ÿ- ]{1,}'?-?[a-zA-ZÀ-ÿ- ]{2,}\s?([a-zA-ZÀ-ÿ-]{1,})?[^ ])/)) {
        return false;
    }
    return true;
};
